"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
exports.initialState = {
    dateString: '',
    isMenuOpen: false,
    isDisabledRCU: false,
    isOnScreenGuideVisible: false,
    longPressModeId: '',
    isKeyBoardOpen: false,
    isIPFailover: false,
};
var reducers = (_a = {},
    _a[constants_1.SET_DATE_STRING] = function (state, action) { return (__assign(__assign({}, state), { dateString: action.payload })); },
    _a[constants_1.SET_IS_MENU_OPEN] = function (state, action) { return (__assign(__assign({}, state), { isMenuOpen: action.payload })); },
    _a[constants_1.SET_IS_DISABLED_RCU] = function (state, action) { return (__assign(__assign({}, state), { isDisabledRCU: action.payload })); },
    _a[constants_1.SET_IS_ON_SCREEN_GUIDE_VISIBLE] = function (state, action) { return (__assign(__assign({}, state), { isOnScreenGuideVisible: action.payload })); },
    _a[constants_1.SET_KEYBOARD_OPEN] = function (state, action) { return (__assign(__assign({}, state), { isKeyBoardOpen: action.payload })); },
    _a[constants_1.SET_LONG_PRESS_MODE_ID] = function (state, action) { return (__assign(__assign({}, state), { longPressModeId: action.payload })); },
    _a[constants_1.SET_IS_IP_FAILOVER] = function (state, action) { return (__assign(__assign({}, state), { isIPFailover: action.payload })); },
    _a);
exports.default = toolkit_1.createReducer(exports.initialState, reducers);
//# sourceMappingURL=reducer.js.map